import {Link, Stack, Typography} from "@mui/material";
import type {SxProps, Theme} from "@mui/material";
import React from "react";
import {Link as RouterLink} from "react-router-dom";

function NavItemLabel(props: {
	link?: string;
	number: string;
	text: string;
	variant: "body1" | "body2";
	metaIcon?: React.ReactElement;
	slotProps?: {number?: {sx?: SxProps<Theme>}};
	onClick?: (event?: React.UIEvent) => void;
}) {
	let label = (
		<Stack component="span" direction="row">
			<Typography
				variant={props.variant}
				color="textSecondary"
				component="span"
				sx={[
					...(props.slotProps?.number?.sx &&
					Array.isArray(props.slotProps.number.sx)
						? props.slotProps.number.sx
						: [props.slotProps?.number?.sx]),
				]}
			>
				{props.number}
			</Typography>
			<Typography
				variant={props.variant}
				color="textPrimary"
				component="span"
				sx={{textAlign: "left"}}
			>
				{props.text}
			</Typography>
		</Stack>
	);

	if (props.link) {
		label = (
			<Link
				component={RouterLink}
				to={props.link}
				variant={props.variant}
				color="textPrimary"
				onClick={props.onClick}
				onKeyDown={props.onClick}
			>
				{label}
			</Link>
		);
	} else if (props.onClick) {
		label = <div onClick={props.onClick}>{label}</div>;
	}

	return (
		<Stack direction="row" sx={{justifyContent: "space-between"}}>
			{label}
			{props.metaIcon}
		</Stack>
	);
}

export default NavItemLabel;
